/* eslint-disable react/prop-types */
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Box,
  Button,
} from "@mui/material";
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";

const DeleteStepInputDialog = ({
  open,
  onClose,
  onConfirm,
  stepName,
  translationPrefix = "newWorkFlow",
}) => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: 2,
          boxShadow: "0 8px 32px rgba(0,0,0,0.15)",
        },
      }}
    >
      <DialogTitle
        sx={{
          background: theme.palette.mode === "dark" ? "grey.900" : "grey.50",
          borderBottom: 1,
          borderColor: "divider",
          pb: 2,
          pt: 3,
          px: 3,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Box
            sx={{
              width: 40,
              height: 40,
              borderRadius: "50%",
              bgcolor: "error.main",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "error.contrastText",
            }}
          >
            <DeleteForeverOutlinedIcon />
          </Box>
          <Box>
            <Typography variant="h6" sx={{ fontWeight: "bold", mb: 0.5 }}>
              {t(`${translationPrefix}.deleteStepInputTitle`)}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {t(`${translationPrefix}.deleteStepInputSubtitle`)}
            </Typography>
          </Box>
        </Box>
      </DialogTitle>

      <DialogContent sx={{ p: 3 }}>
        <Typography variant="body1" sx={{ mb: 2 }}>
          {t(`${translationPrefix}.deleteStepInputMessage`, {
            stepName: stepName,
          })}
        </Typography>
        <Box
          sx={{
            p: 2,
            bgcolor: theme.palette.mode === "dark" ? "grey.900" : "error.50",
            borderRadius: 1,
            border: 1,
            borderColor: "error.light",
          }}
        >
          <Typography
            variant="body2"
            color="error.main"
            sx={{ fontWeight: "medium" }}
          >
            ⚠️ {t(`${translationPrefix}.deleteStepInputWarning`)}
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions sx={{ p: 3, gap: 2 }}>
        <Button
          onClick={onClose}
          variant="outlined"
          color="primary"
          sx={{
            borderRadius: 2,
            px: 3,
            py: 1,
            textTransform: "none",
            fontWeight: "medium",
          }}
        >
          {t(`${translationPrefix}.cancelDelete`)}
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="error"
          sx={{
            borderRadius: 2,
            px: 3,
            py: 1,
            textTransform: "none",
            fontWeight: "bold",
            boxShadow: 2,
            "&:hover": {
              boxShadow: 4,
              transform: "translateY(-1px)",
            },
          }}
        >
          {t(`${translationPrefix}.confirmDelete`)}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteStepInputDialog;
